/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_PlayersInputs */

const th_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่น`)
};

const en_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Players`)
};

const ja_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手`)
};

const zh_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球员`)
};

const es_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugadores`)
};

const pt_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogadores`)
};

const id_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain`)
};

const fr_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joueurs`)
};

const tl_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga manlalaro`)
};

const vi_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ`)
};

const ko_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수`)
};

const de_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spieler`)
};

const ru_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игроки`)
};

const tr_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncular`)
};

const it_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giocatori`)
};

const pl_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawodnicy`)
};

const uk_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гравці`)
};

const hi_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी`)
};

const ar_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللاعبون`)
};

const ms_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain`)
};

const bn_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলোয়াড়`)
};

const zh_tw2_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員`)
};

const zh_hk2_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員`)
};

const ur_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھلاڑی`)
};

const fa_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکنان`)
};

const sw_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji`)
};

const nl_admin_players = /** @type {(inputs: Admin_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelers`)
};

/**
* | output |
* | --- |
* | "Players" |
*
* @param {Admin_PlayersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_players = /** @type {((inputs?: Admin_PlayersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_PlayersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_players(inputs)
	if (locale === "ja") return ja_admin_players(inputs)
	if (locale === "zh") return zh_admin_players(inputs)
	if (locale === "es") return es_admin_players(inputs)
	if (locale === "pt") return pt_admin_players(inputs)
	if (locale === "id") return id_admin_players(inputs)
	if (locale === "fr") return fr_admin_players(inputs)
	if (locale === "tl") return tl_admin_players(inputs)
	if (locale === "vi") return vi_admin_players(inputs)
	if (locale === "ko") return ko_admin_players(inputs)
	if (locale === "de") return de_admin_players(inputs)
	if (locale === "ru") return ru_admin_players(inputs)
	if (locale === "tr") return tr_admin_players(inputs)
	if (locale === "it") return it_admin_players(inputs)
	if (locale === "pl") return pl_admin_players(inputs)
	if (locale === "uk") return uk_admin_players(inputs)
	if (locale === "hi") return hi_admin_players(inputs)
	if (locale === "ar") return ar_admin_players(inputs)
	if (locale === "ms") return ms_admin_players(inputs)
	if (locale === "bn") return bn_admin_players(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_players(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_players(inputs)
	if (locale === "ur") return ur_admin_players(inputs)
	if (locale === "fa") return fa_admin_players(inputs)
	if (locale === "sw") return sw_admin_players(inputs)
	if (locale === "nl") return nl_admin_players(inputs)
	return en_admin_players(inputs)
});